// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__16zLt","title":"Container_title__1FtPQ"};